import { Flex, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useEffect, useState } from 'react'
import { useData } from 'services/data/DataProvider';
import { currencyformat } from 'views/trader/trades/variables/FormatData';
import { Trade } from 'views/trader/trades/variables/types';

const DashCalendarModalDayStats = (props: { trades: Trade[] }) => {

    const { defaultcurrency } = useData();

    const textColor = useColorModeValue('secondaryGray.900', 'white');
    const textColorSecondary = useColorModeValue('secondaryGray.600','secondaryGray.500' );

    const [nett, setNett] = useState(0)
    const [nettcolor, setNettcolor] = useState(textColor);
    const [winloss, setWinloss] = useState('');
    const [winlosscol, setWinlosscol] = useState(textColor);
    const [rvalue, setRvalue] = useState('')
    const [rvaluecol, setRvaluecol] = useState('')

    useEffect(() => {
        let nt = 0;
        let win = 0;
        let loss = 0;
        let rval = 0;
        for (let tr of props.trades) {

            let pl = tr.profitloss - tr.fees;
            win += (pl > 0 ? 1 : 0)
            loss += (pl < 0 ? 1 : 0)
            nt += pl;
            rval += tr.rvalue;
        }
        setNett(nt);
        setNettcolor(nt > 0 ? 'green.500' : (nt < 0 ? 'red.500' : textColor))
        let wlratio = (win / (loss === 0 ? 1 : loss));
        setWinloss(win + " : " + loss + '  (' + wlratio.toFixed(2) + ')')
        setWinlosscol(wlratio >= 1 ? 'green.500' : (wlratio >= 0.5 ? 'orange.500' : 'red.500'))
        setRvalue(rval.toFixed(2))
        setRvaluecol(rval >= 1 ? 'green.500' : (rval > 0 ? 'orange.500' : 'red.500'))
    }, [props.trades])

    return (
        <>
            <Flex direction={('row')} gap={4}>
                <Card flexDirection="row" w="100%" p="15px" justifyContent='center' borderWidth={'1px'} bg='transparent'>
                    <Flex align="center" justify="space-between" w="100%">
                        <Flex direction="column" textAlign={'center'} w='100%'>
                            <Text color={textColorSecondary} fontSize="sm" fontWeight="500" mb="10px" lineHeight="100%">
                                Nett P/L
                            </Text>
                            <Text color={nettcolor} fontSize="md" fontWeight="700" lineHeight="100%" mb="8px" >
                                {currencyformat(nett, defaultcurrency)}
                            </Text>
                        </Flex>
                    </Flex>
                </Card>
                <Card flexDirection="row" w="100%" p="15px" justifyContent='center' borderWidth={'1px'} bg='transparent'>
                    <Flex align="center" justify="space-between" w="100%">
                        <Flex direction="column"  textAlign={'center'} w='100%'>
                            <Text color={textColorSecondary} fontSize="sm" fontWeight="500" mb="10px" lineHeight="100%">
                                Win : Loss
                            </Text>
                            <Text color={winlosscol} fontSize="md" fontWeight="700" lineHeight="100%" mb="8px" >
                                {winloss}
                            </Text>
                        </Flex>
                    </Flex>
                </Card>
                <Card flexDirection="row" w="100%" p="15px" justifyContent='center' borderWidth={'1px'} bg='transparent'>
                    <Flex align="center" justify="space-between" w="100%">
                        <Flex direction="column"  textAlign={'center'} w='100%'>
                            <Text color={textColorSecondary} fontSize="sm" fontWeight="500" mb="10px" lineHeight="100%">
                                Total R
                            </Text>
                            <Text color={rvaluecol} fontSize="md" fontWeight="700" lineHeight="100%" mb="8px" >
                                {rvalue}
                            </Text>
                        </Flex>
                    </Flex>
                </Card>
            </Flex>


        </>
    )
}

export default DashCalendarModalDayStats